import { PropsWithChildren } from 'react';
import { AuthInProgress } from 'shared/providers';
import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';

export function AuthenticationRequired({ children }: PropsWithChildren<{}>) {
    useMsalAuthentication(InteractionType.Redirect);
    return (
        <>
            <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <AuthInProgress />;
            </UnauthenticatedTemplate>
        </>
    );
}
